import { ApiAnimationCodeReturn } from '../shared/types/avatar/types';
import { type IHttpClient } from './contracts/IHttpClient';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchAnimationCode = async (
  client: IHttpClient,
  token: string
): Promise<ApiAnimationCodeReturn> => {
  const endpoint = apiUrl + '/translation-link/link/' + token;
  return client.get<ApiAnimationCodeReturn>(endpoint);
};
